module.exports = __webpack_public_path__ + "static/media/calling_up2.20cfcc44.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/hymns/calling_up2.pdf
// module id = 784
// module chunks = 2